/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.embed.external'

export { $nsid }

/** A representation of some externally linked content (eg, a URL and 'card'), embedded in a Bluesky record (eg, a post). */
type Main = { $type?: 'app.bsky.embed.external'; external: External }

export type { Main }

/** A representation of some externally linked content (eg, a URL and 'card'), embedded in a Bluesky record (eg, a post). */
const main = l.typedObject<Main>(
  $nsid,
  'main',
  l.object({ external: l.ref<External>((() => external) as any) }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type External = {
  $type?: 'app.bsky.embed.external#external'
  uri: l.UriString
  title: string
  description: string
  thumb?: l.BlobRef
}

export type { External }

const external = l.typedObject<External>(
  $nsid,
  'external',
  l.object({
    uri: l.string({ format: 'uri' }),
    title: l.string(),
    description: l.string(),
    thumb: l.optional(l.blob({ accept: ['image/*'], maxSize: 1000000 })),
  }),
)

export { external }

type View = { $type?: 'app.bsky.embed.external#view'; external: ViewExternal }

export type { View }

const view = l.typedObject<View>(
  $nsid,
  'view',
  l.object({ external: l.ref<ViewExternal>((() => viewExternal) as any) }),
)

export { view }

type ViewExternal = {
  $type?: 'app.bsky.embed.external#viewExternal'
  uri: l.UriString
  title: string
  description: string
  thumb?: l.UriString
}

export type { ViewExternal }

const viewExternal = l.typedObject<ViewExternal>(
  $nsid,
  'viewExternal',
  l.object({
    uri: l.string({ format: 'uri' }),
    title: l.string(),
    description: l.string(),
    thumb: l.optional(l.string({ format: 'uri' })),
  }),
)

export { viewExternal }
